import { render } from "./hero.vue?vue&type=template&id=2fb9c3f0&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=2fb9c3f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fb9c3f0"

export default script